<template>
  <div>
    <CouponPay
      v-if="visible"
      class="test-class"
      :visible="visible"
      :coupon-config="couponConfig"
      :pay-from="payFrom"
      :is-pdf-api="true"
      :pay-success-tip="paySuccessTip"
      @paySuccess="paySuccess"
      @closeModal="closeModal"
      @changeCoupon="changeCoupon"
    />
  </div>
</template>

<script>
import * as Coupon from '@/api/coupon'
import client from '@/client/'
import CouponPay from '@/components/common/CouponPay'
import { PAGE_NUM } from '@/config/dataMap.js'
import { mapActions, mapGetters } from 'vuex'

const ACT_FRM = 'act_202106_pc_pdf'
const PAY_FROM = PAGE_NUM.PdfHome

export default {
  name: 'RetainUserPay',
  components: { CouponPay },

  data () {
    return {
      visible: false,
      payFrom: PAY_FROM,
      isFirst: true,
      couponConfig: {},
      paySuccessTip: '恭喜您已成为PDF会员！'
    }
  },

  computed: {
    ...mapGetters([
      'openId',
      'token',
      'userInfo',
    ]),

    // 活动已过期
    isExpired () {
      if (!this.couponConfig.expires) {
        return true
      }
      return Date.now() > Number(this.couponConfig.expires) * 1000
    },
  },

  watch: {
    userInfo () {
      this.init()
    },
  },

  created () {
    this.init()
  },

  methods: {
    ...mapActions('user', ['refresh']),

    async init () {
      if (this.isFirst) {
        this.isFirst = false

        await this.getCouponConfig()
        if (this.isExpired) {
          this.closeModal()
          return
        }

        this.visible = true
        this.report({ showed: 3 })
      }
    },

    async getCouponConfig () {
      const res = await Coupon.getCouponConfig({ frm: ACT_FRM })

      if (res.resp_common.ret === 0 && res.act_show && res.act_show[ACT_FRM]) {
        const act = res.act_show[ACT_FRM]
        this.couponConfig = act.config
      }
    },

    paySuccess () {
      this.refresh({
        token: this.token,
        open_id: this.openId,
        webRefresh: 1,
      })
    },

    changeCoupon (id) {
      this.report({ clicked: 5 })
    },

    closeModal (hasPay) {
      this.report({ clicked: 3 })

      const time = hasPay ? 2000 : 0
      setTimeout(() => {
        this.visible = false
        window.close()
      }, time)
    },

    report ({ showed = 0, clicked = 0 }) {
      client.retainUsers.REPORT.reportQuitRetainUsers({ showed, clicked })
    },
  },
}
</script>
